import { Avatar_v2 as Avatar, Typography, TypographyVariantsEnum } from '@mindly/ui-components';
import React from 'react';

type ProfileAvatarFeatureProps = {
  onPress: () => void;
  avatar?: string;
  fullName?: string;
};
function ProfileAvatarFeature({ onPress, avatar = '', fullName }: ProfileAvatarFeatureProps) {
  return (
    <div className="flex flex-col justify-center items-center mt-6 mb-6">
      <button onClick={onPress}>
        <Avatar src={avatar} variant="medium" />
      </button>
      <Typography className="mt-4" variant={TypographyVariantsEnum.Title24Semi}>
        {fullName}
      </Typography>
    </div>
  );
}

export default React.memo<ProfileAvatarFeatureProps>(ProfileAvatarFeature);
